<h3 class="schema__advantage-item-title">{{ 'main.schemas.giftShop' | translate }}</h3>

<div class="schema__card schema__paragraph-regular">
  {{ 'main.schemas.earnRewards' | translate }}
</div>

<img
  width="200"
  loading="lazy"
  alt="Three AstralFund credit cards"
  src="/assets/schemas/card-8-bg.png"
  class="schema__image schema__image_8"
/>

<rp-home-coming-soon-label tall />
